/**
  * Bug #503
  * @Author Anupama P
  * @Date 06 Sep 2021
  */
 import { Col, Row, InputItem, DatePicker } from 'components'
 import { APP_LOCAL_DATE_FORMAT } from 'config/constants'
 import { getKeyName } from 'shared/utils/formlocalization'
 
 interface Props {
   preFix?: String;
   keyName?: any;/*Bug #503-For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
   onAccordionFieldChange?: any;
 }
 
  const defaultProps = {
    onAccordionFieldChange: () => { return Promise.resolve() }
  };

 const DateOfBirth = (props: Props) => {
     return (
         <Col sm={12} md={6} lg={4}>
           <Row>
             {/* <CommonInputLabel label="Date Of Birth"/> */}
           
             <Col sm={12} md={12} lg={12}>
               <InputItem label="Date Of Birth"
                 //name={[props?.preFix, getKeyName(props?.keyName, "dateOfBirth")]}
                 name={
                   props?.preFix
                       ? [props?.preFix, getKeyName(props?.keyName, "dateOfBirth")]
                       : getKeyName(props?.keyName, "dateOfBirth")/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
                 }
                 rules={[{ required: true, message: "Enter date of birth" },{ validator: props.onAccordionFieldChange }]}
               >
                 <DatePicker format={APP_LOCAL_DATE_FORMAT} className='form-control' />
               </InputItem>
             </Col>
           </Row>
         </Col>
     )
 }
 
 DateOfBirth.defaultProps = defaultProps;
 export default DateOfBirth
 